<template>
    <div class="map-right">
        <divBox class="all-round">
            <template>
                <div>
                    <boxList :list="allRoundData" :line="2"></boxList>
                </div>
            </template>
        </divBox>

        <div class="power-chart mt-50">
            <divBox :title="'累计入网司机数'">
                <template>
                    <rightcharts
                        v-if="rightchartsShow"
                        :id="'rightmapsijishuchart'"
                        :xAxis="xAxis"
                        :yAxis="{name: '入网司机数'}"
                        :series="[cumEnrollDriverNum]" />
                </template>
            </divBox>
            <divBox :title="'累计入网车辆数'">
                <template>
                    <rightcharts
                        v-if="rightchartsShow"
                        :id="'rightmapcheliangchart'"
                        :xAxis="xAxis"
                        :yAxis="{name: '入网车辆数'}"
                        :series="[cumEnrollVehicleNum]" />
                </template>
            </divBox>
        </div>

        <div class="power-chart mt-50">
            <divBox :title="'车型运营数量'">
                <template>
                    <!-- <rightcategory
                        v-if="rightcategorySiteShow"
                        :id="'rightcategorySiteShow'"
                        :xAxis="sitexAxis"
                        :series="[supportVehicleCount]" /> -->
                    <rightCharts1
                        v-if="rightcategoryCarShow"
                        :id="'rightcategoryCarShow'"
                        :xAxis="carxAxis"
                        :colors="['#3FFFD9', '#60F5FF']"
                        :nClass="'right1'"
                        :yAxis="{name: '车型运营数量'}"
                        :series="[vehicleBrandCount]" />
                </template>
            </divBox>
            <!-- <divBox :title="'车型运营数量'">
                <template>
                    <rightcategory
                        v-if="rightcategoryCarShow"
                        :id="'rightcategoryCarShow'"
                        :xAxis="carxAxis"
                        :series="[vehicleBrandCount]" />
                </template>
            </divBox> -->
        </div>
    </div>
</template>

<script>
import boxTitle from '../../components/boxTitle.vue'
import divBox from '../../components/divBox.vue'
import boxList from '../../components/boxList.vue'

import rightcharts from './right-charts.vue'
import rightcategory from './right-category.vue'
import rightCharts1 from './right-charts-1.vue'

import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    components: {
        boxTitle,
        divBox,
        boxList,
        rightcharts,
        rightcategory,
        rightCharts1
    },
    data() {
        return {
            allRoundData: [
                {
                    icon: 'user1',
                    title: '活跃用户数',
                    value: '366',
                    unit: '',
                    color: '#36FBFB'
                },
                {
                    icon: 'car1',
                    title: '活跃车辆数',
                    value: '366',
                    unit: '',
                    color: '#43FFB9'
                },
                {
                    icon: 'attract',
                    title: '用户粘性',
                    value: '366',
                    unit: '%',
                    color: '#36FBFB'
                },
                {
                    icon: 'car2',
                    title: '车辆粘性',
                    value: '366',
                    unit: '%',
                    color: '#43FFB9'
                }
            ],
            xAxis: {},
            cumEnrollDriverNum: [], // 累计入网司机
            cumEnrollVehicleNum: [], // 累计入网车辆
            rightchartsShow: false, // 累计入网车辆 + 司机chatts 显示
            rightcategorySiteShow: false, // 站型
            sitexAxis: {},
            supportVehicleCount: [],
            rightcategoryCarShow: false, // 车型
            carxAxis: {},
            vehicleBrandCount: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        // 初始化
        async init() {
            // 用户属性
            let yonghushuxing = await this.yonghushuxing()
            // 全国-累计入网司机数入网车辆数
            this.leijiruwangsijishucheliangshu()

            // 全国-站型运营数量
            this.zhanxingyunyingshuliang()
            // 全国-车型运营数量
            this.chexingyunyingshuliang() 
            
            // debugger
            this.allRoundData[0].value = yonghushuxing.userActiveNum
            this.allRoundData[1].value = yonghushuxing.vehicleAvtiveNum
            this.allRoundData[2].value = yonghushuxing.userViscidity
            this.allRoundData[3].value = yonghushuxing.vehicleViscidity
        },
        // 用户属性
        yonghushuxing() {
            return new Promise((resolve, rejiect) => {
                let params = {
                    "enCode": "TiDB-Energy-quanguo-yonghushuxing"
                }
                dataInterface
                    .dataFaceApi(params)
                    .then((res) => {
                        console.log('=========', res)
                        if(!res || !res.length || !res[0]) resolve({})
                        resolve(res[0])
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            })
        },
        // 全国-累计入网司机数入网车辆数
        leijiruwangsijishucheliangshu() {
            let params = {
                "enCode": "TiDB-Energy-quanguo-leijiruwangsijishucheliangshu"
            }
            let xdata = []
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('leijiruwangsijishucheliangshu=========', res)
                    if(!res || !res.length || !res[0]) return
                    // resolve(res[0])
                    let data = res.reverse()
                    data.map((item) => {
                        xdata.push(item.cur_date.split('-')[1])
                        this.cumEnrollDriverNum.push(item.cumEnrollDriverNum)
                        this.cumEnrollVehicleNum.push(item.cumEnrollVehicleNum)
                    })
                    this.xAxis.data = xdata
                    this.rightchartsShow = true
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // 全国-站型运营数量
        zhanxingyunyingshuliang() {
            let params = {
                "enCode": "TiDB-Energy-quanguo-zhanxingyunyingshuliang"
            }
            let xdata = []
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('zhanxingyunyingshuliang=========', res)
                    if(!res || !res.length || !res[0]) return
                    // resolve(res[0])
                    res.map(item => {
                        xdata.push(item.supportVehicle)
                        this.supportVehicleCount.push(parseFloat(item.supportVehicleCount, 10))
                    })
                    this.sitexAxis.data = xdata
                    this.rightcategorySiteShow = true
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // 全国-车型运营数量
        chexingyunyingshuliang() {
            let params = {
                "enCode": "TiDB-Energy-quanguo-chexingyunyingshuliang"
            }
            let xdata = []
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('chexingyunyingshuliang=========', res)
                    if(!res || !res.length || !res[0]) return
                    // resolve(res[0])
                    let nres = res.sort((a, b) => { return parseInt(b.vehicleBrandCount, 10) - parseInt(a.vehicleBrandCount, 10)})
                    nres.map(item => {
                        xdata.push(item.vehicleBrand)
                        this.vehicleBrandCount.push(parseFloat(item.vehicleBrandCount, 10))
                    })
                    this.carxAxis.data = xdata
                    this.rightcategoryCarShow = true
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../comm.scss';
.map-right {
    margin-top: 20px;
    .all-round {
        padding: 15px;
        margin-top: 20px;
    }
    .power-chart {
        display: flex;
        > div {
            margin: 0 3px;
            &:first-child {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
    // .power-chart1 {
    //     margin-top: 6px;
    // }
}
</style>